module.exports = __webpack_public_path__ + "eb183ffc578af856f733784a28b0aa7d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-29.png
// module id = 3120
// module chunks = 0